export default __webpack_public_path__ + "static/media/icon-shanghai-renshe-android.1c995f11.png";